import { render, staticRenderFns } from "./SettingSection.vue?vue&type=template&id=6f2208b7&scoped=true"
import script from "./SettingSection.vue?vue&type=script&lang=js"
export * from "./SettingSection.vue?vue&type=script&lang=js"
import style0 from "./SettingSection.vue?vue&type=style&index=0&id=6f2208b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2208b7",
  null
  
)

export default component.exports